import { useDispatch } from 'react-redux';
import { MESSAGE_TYPE } from 'app/constants/message';
import { showMessage } from 'app/store/fuse/messageSlice';

export default function useShowMessage() {
  const dispatch = useDispatch();
  return (
    text,
    type = MESSAGE_TYPE.SUCCESS,
    duration = 3000,
    anchorOrigin = {
      vertical: 'top',
      horizontal: 'right',
    }
  ) =>
    dispatch(
      showMessage({
        message: text,
        autoHideDuration: duration,
        anchorOrigin,
        variant: type,
      })
    );
}
